__turbopack_context__.v({
  "appear-slide-left": "ServiceStart-module-scss-module__kkaH4G__appear-slide-left",
  "bounceTwice": "ServiceStart-module-scss-module__kkaH4G__bounceTwice",
  "divider": "ServiceStart-module-scss-module__kkaH4G__divider",
  "fade-in-bottom": "ServiceStart-module-scss-module__kkaH4G__fade-in-bottom",
  "fade-in-left": "ServiceStart-module-scss-module__kkaH4G__fade-in-left",
  "fade-in-right": "ServiceStart-module-scss-module__kkaH4G__fade-in-right",
  "fadeIn": "ServiceStart-module-scss-module__kkaH4G__fadeIn",
  "fixedBackground": "ServiceStart-module-scss-module__kkaH4G__fixedBackground",
  "heading": "ServiceStart-module-scss-module__kkaH4G__heading",
  "loader": "ServiceStart-module-scss-module__kkaH4G__loader",
  "puff-in-center": "ServiceStart-module-scss-module__kkaH4G__puff-in-center",
  "puff-in-left": "ServiceStart-module-scss-module__kkaH4G__puff-in-left",
  "pulse": "ServiceStart-module-scss-module__kkaH4G__pulse",
  "pulse-contact": "ServiceStart-module-scss-module__kkaH4G__pulse-contact",
  "scrollDownBtn": "ServiceStart-module-scss-module__kkaH4G__scrollDownBtn",
  "shake-bottom": "ServiceStart-module-scss-module__kkaH4G__shake-bottom",
  "slide-again": "ServiceStart-module-scss-module__kkaH4G__slide-again",
  "slide-in-right": "ServiceStart-module-scss-module__kkaH4G__slide-in-right",
  "start": "ServiceStart-module-scss-module__kkaH4G__start",
  "stepContent-entrance": "ServiceStart-module-scss-module__kkaH4G__stepContent-entrance",
  "text": "ServiceStart-module-scss-module__kkaH4G__text",
  "wrapper": "ServiceStart-module-scss-module__kkaH4G__wrapper",
});
